import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Injeta token JWT de localStorage (chave 'concilhe_access')
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('concilhe_access');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface DFCPeriodo {
  empresa_id: string;
  periodos: string[];
  centros: string[];
  dados: Record<string, Record<string, Record<string, { realizado: number; previsto: number; ano_anterior: number }>>>;
  consolidado: Record<string, Record<string, { realizado: number; previsto: number; ano_anterior: number }>>;
}

export interface KPIs {
  empresa_id: string;
  periodo: { inicio: string; fim: string };
  kpis: Record<string, { nome: string; valor: number | null; formatado: string; meta: number | null }>;
  dados_base: Record<string, number>;
}

export interface Importacao {
  importacao_id: string;
  status: string;
  tipo: string;
  arquivo: string;
  total_registros: number;
  registros_ok: number;
  created_at: string;
}

export const dfcApi = {
  calcular: (empresaId: string, inicio: string, fim: string) =>
    api.post<DFCPeriodo>('/api/dfc/', { empresa_id: empresaId, periodo_inicio: inicio, periodo_fim: fim }),
};

export const kpisApi = {
  calcular: (empresaId: string, inicio: string, fim: string) =>
    api.get<KPIs>('/api/kpis/', { params: { empresa_id: empresaId, periodo_inicio: inicio, periodo_fim: fim } }),
};

export const importacaoApi = {
  listar: (empresaId: string) =>
    api.get<Importacao[]>('/api/importacao/historico/', { params: { empresa_id: empresaId } }),
};

export default api;
